import React, { useCallback } from 'react';
import { ordersRatingStore } from '../OrdersRatingScreen/store/ordersRatingStore';
import OrderScreen from './OrderScreen';
import { OrderStoreContext } from './context';
import { ordersHistoryStore } from '~/mobx/ordersHistoryStore/ordersHistoryStore';
import { callCenterStore } from '~/mobx/ordersStore/callCenterStore';
import { liveOrdersStore } from '~/mobx/ordersStore/liveOrdersStore';
import { OrderStore } from '~/mobx/orderStore';
import { history } from '~/services/history';
import { SCREENS } from '~/constants/screens';

const historyOrderStore = new OrderStore(ordersHistoryStore);
const liveOrderStore = new OrderStore(liveOrdersStore);
const callCenterOrderStore = new OrderStore(callCenterStore);
const ratingOrderStore = new OrderStore(ordersRatingStore);

export const HistoryOrderScreen = () => {
  const handleBack = useCallback(() => {
    history.push(SCREENS.HISTORY());
  }, []);

  return (
    <OrderStoreContext.Provider value={{ store: historyOrderStore }}>
      <OrderScreen showScreenHeader onBack={handleBack} />
    </OrderStoreContext.Provider>
  );
};

export const RatingOrderScreen = () => {
  const handleBack = useCallback(() => {
    history.push(SCREENS.ORDERS_RATING());
  }, []);

  return (
    <OrderStoreContext.Provider value={{ store: ratingOrderStore }}>
      <OrderScreen showScreenHeader onBack={handleBack} />
    </OrderStoreContext.Provider>
  );
};

export const LiveOrderScreen = () => {
  return (
    <OrderStoreContext.Provider value={{ store: liveOrderStore }}>
      <OrderScreen />
    </OrderStoreContext.Provider>
  );
};

export const CallCenterOrderScreen = () => {
  return (
    <OrderStoreContext.Provider value={{ store: callCenterOrderStore }}>
      <OrderScreen />
    </OrderStoreContext.Provider>
  );
};
